import 'intersection-observer'

import Vue from 'vue'
import App from './App'
import router from './router'
import './styles/main.scss';

/**
 * Add razzUse to Vue prototype
 */
import _some from 'lodash/some';
Vue.razzUse = function(name, plugin, options) {
    const plugins = Vue._installedPlugins;

    if(_some(plugins, plugin => plugin.razzId === name)) return;

    plugin.razzId = name;
    Vue.use(plugin, options);
};

import AsyncComputed from 'vue-async-computed';
Vue.razzUse('async-computed', AsyncComputed);
// Vue.use(AsyncComputed);

/**
 * Vue Scroll To
 * --------------------
 * https://github.com/rigor789/vue-scrollto
 */
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo);

/**
 * Vee Validate
 * --------------------
 * https://github.com/baianat/vee-validate
 */
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    classes: true
});


/**
 * FontAwesome Icons & Components
 * ------------------------------
 * https://fontawesome.com/icons?d=gallery
 * https://github.com/FortAwesome/vue-fontawesome
 */
import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);

/**
 * WordPress Image
 * --------------------
 * Our custom component for loading images from wordpress
 * includes lazy loading below the fold
 */
import WpImage from './modules/includes/WpImage'
Vue.component('wp-image', WpImage);

/**
 * Custom Directives
 * -----------------
 */
import msGrid from './directives/msGrid'
Vue.directive('ms-grid', msGrid);

import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility);

/**
 * Globally register Vue components exposed to the window from plugins
 */
import _each from 'lodash/each';
import _isFunction from 'lodash/isFunction';
_each(window.vueComponents || {}, (vueComponent, key) => {
    Vue.component(key, _isFunction(vueComponent) ? vueComponent.call(this, Vue) : vueComponent);
});

// Vue Instance
Vue.config.productionTip = false;

new Vue({
    el: '#theme-app',
    router,
    components: { App },
    render: h => h(App)
});